var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-checkbox',{class:_vm.classObject,attrs:{"indeterminate":_vm.indeterminate,"disabled":_vm.disabled,"input-value":_vm.inputValue,"dark":_vm.dark,"hide-details":""},on:{"change":function($event){return _vm.$emit('checkbox-changed', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }